export function CHANNEL_CHAT(id) {
  return `chat/live/${id}`;
}

export function CHANNEL_VOD(id) {
  return `vod/${id}`;
}

export function CHANNEL_HOME() {
  return `home`;
}